import React from 'react';
import './Peulis.css';
import choose1 from '../../images/choose/choose-1.png';
import choose2 from '../../images/choose/choose-2.png';
import choose3 from '../../images/choose/choose-3.png';

const Peulis = () => {
    return (
        <div>
            <h1 className="mt-5 text-center tour-title">Why Peulis?</h1>
            <p className="paragraph pb-5">Lorem ipsum dolor sit amet, conseetuer adipiscing elit. Aenan comdo igula eget. Aenean massa cum sociis Theme natoque.</p>
            <div className="chooseTour-container">
                <div className="border shadow-lg p-4 chooseTour">
                    <img style={{width:'100px'}} src={choose1} alt="" />
                    <h3 className="pt-5 pb-2">Safe Travel</h3>
                    <p>printing and typesetting industry has been printing the industry’s ipsum</p>
                </div>
                <div className="border shadow-lg p-4 chooseTour">
                    <img style={{width:'100px'}} src={choose2} alt="" />
                    <h3 className="pt-5 pb-2">Awesome Guide</h3>
                    <p>printing and typesetting industry has been printing the industry’s ipsum</p>
                </div>
                <div className="border shadow-lg p-4 chooseTour">
                    <img style={{width:'100px'}} src={choose3} alt="" />
                    <h3 className="pt-5 pb-2">Save Money</h3>
                    <p>printing and typesetting industry has been printing the industry’s ipsum</p>
                </div>
            </div>
        </div>
    );
};

export default Peulis;